import styled from "styled-components";

const Time = styled.textarea`
  border: 1px solid #007aff;
  min-height: 20px;
  height: 20px;
  line-height: 20px;
  width: 500px;
  max-width: calc(100% - 20px);
`;

export default Time;
